import {
    assistantAsking, assistantAskingForAction, assistantAskingForExample,
    assistantAskingForInstructions,
    assistantAskingForRequirements, assistantAskingForSchema,
    systemInstruction,
    userSaying
} from "../Utils";

export const generateFreeGenerationPrompt = (vars: {
    prompt: string
}) => userSaying(vars.prompt)

export const generatePlaceNamePrompt = (vars: {
    place: string,
    translations: string[],
    country: string
}) => systemInstruction("Ты специалист в нейминге географических объектов")
    .concat(userSaying(`Я работаю над созданием локации`))
    .concat(assistantAsking("В какой стране находится локация?", vars.country))
    .concat(assistantAsking("Опиши локацию", vars.place))
    .concat(assistantAsking("На какие языки нужно перевести название?", vars.translations.join(', ')))
    .concat(assistantAskingForInstructions([
        "Сгенерируй названия локации, которые соответствуют стране.",
        "Переведи на указанные языки."
    ]))
    .concat(assistantAskingForRequirements([
        "Сгенерируй 15 названий локации.",
        "Если перевод не соответствует стране, используй транслитерацию.",
        "Язык перевода не должен влиять на название.",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": [{"English": string, "Russian": string}]}'))
    .concat(assistantAskingForExample({
        data: [
            {
                English: "Morning Brew",
                Russian: "Морнинг Брю",
                Spanish: "Morning Brew"
            }, {
                English: "Сozy Сorner",
                Russian: "Коузи Корнер",
                Spanish: "Morning Brew"
            }
        ]
    }))
    .concat(assistantAskingForAction("Сгенерируй названия для локации"))

export const generateOtherNamePrompt = (vars: {
    description: string,
    translations: string[]
}) => systemInstruction("Ты специалист в нейминге")
    .concat(userSaying(`Я работаю над названием`))
    .concat(assistantAsking("Опиши объект", vars.description))
    .concat(assistantAsking("На какие языки нужно перевести имя или название?", vars.translations.join(', ')))
    .concat(assistantAskingForInstructions([
        "Сгенерируй названия, которые соответствуют стране.",
        "Переведи на указанные языки."
    ]))
    .concat(assistantAskingForRequirements([
        "Сгенерируй 15 названий.",
        "Язык перевода не должен влиять на название.",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": [{"English": string, "Russian": string}]}'))
    .concat(assistantAskingForExample({
        data: [
            {
                English: "Sleepeen",
                Russian: "Слипин",
                Spanish: "Sleepeen"
            }, {
                English: "Dreamster",
                Russian: "Дримстер",
                Spanish: "Dreamster"
            }
        ]
    }))
    .concat(assistantAskingForAction("Сгенерируй имя или название"))

export const generatePersonNamePrompt = (vars: {
    sex: string,
    translations: string[],
    country: string
}) => systemInstruction("Ты специалист в именах персонажей")
    .concat(userSaying(`Я работаю над созданием персонажа`))
    .concat(assistantAsking("Из какой страны персонаж?", vars.country))
    .concat(assistantAsking("Какого пола персонаж?", vars.sex))
    .concat(assistantAsking("На какие языки нужно перевести имя?", vars.translations.join(', ')))
    .concat(assistantAskingForInstructions([
        "Сгенерируй названия, которые соответствуют стране.",
        "Переведи на указанные языки."
    ]))
    .concat(assistantAskingForRequirements([
        "Сгенерируй 15 названий локации.",
        "Если перевод не соответствует стране, используй транслитерацию.",
        "Язык перевода не должен влиять на название.",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": [{"English": string, "Russian": string}]}'))
    .concat(assistantAskingForExample({
        "data": [
            {
                English: "Jack Donald Stone",
                Russian: "Джек Дональд Стоун",
                Spanish: "Jack Donald Stone"
            }, {
                English: "Peter Brown",
                Russian: "Питер Браун",
                Spanish: "Peter Brown"
            }
        ]
    }))
    .concat(assistantAskingForAction("Сгенерируй полное имя для персонажа"))

export const generateTranslationPrompt = (vars: {
    text: string,
    translations: string[]
}) => systemInstruction("Ты профессиональный переводчик-полиглот")
    .concat(userSaying(`Нужно перевести текст на указанные языки`))
    .concat(assistantAsking("На какие языки нужно перевести текст?", vars.translations.join(', ')))
    .concat(assistantAskingForInstructions([
        "Проанализируй текст и определи все возможные переводы.",
        "Переведи текст.",
        "Предоставь все возможные варианты перевода."
    ]))
    .concat(assistantAskingForRequirements([
        "Каждый перевод должен начинаться с большой буквы.",
        "Результат должен быть в формате json"
    ]))
    .concat(assistantAskingForSchema('{"data": [{"English": string, "Russian": string}]}'))
    .concat(assistantAskingForExample({
        data: [
            {
                English: "Tree",
                Russian: "Дерево",
                Belarusian: "Дрэва"
            }, {
                English: "Wood",
                Russian: "Дерево",
                Belarusian: "Дрэва"
            }
        ]
    }))
    .concat(assistantAsking("Какой текст перевести?", `"${vars.text}"`))